var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 126,
    viewBox: "0 0 151 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.314 84.5174C129.846 87.0524 134.445 89.0336 140.04 89.0336C145.993 89.0336 150.819 86.7911 150.819 84.0252C150.819 81.2589 145.993 79.0168 140.04 79.0168C136.055 79.0168 132.577 80.0227 130.712 81.5171L83.538 76.7749L104.688 69.0846C106.299 69.6168 108.268 69.9308 110.395 69.9308C115.843 69.9308 120.26 67.8786 120.26 65.3468C120.26 62.8152 115.843 60.7627 110.395 60.7627C104.946 60.7627 100.53 62.8152 100.53 65.3468C100.53 65.9386 100.774 66.5033 101.213 67.0227L76.3724 76.0552L38.6649 72.3205C38.0305 70.0733 33.8961 68.3383 28.8871 68.3383C23.4389 68.3383 19.022 70.3908 19.022 72.9224C19.022 75.4539 23.4389 77.5064 28.8871 77.5064C32.4392 77.5064 35.5521 76.6336 37.2889 75.3246L70.3314 78.5971L20.0299 99.9524C18.0621 99.3164 15.6727 98.9424 13.0939 98.9424C6.37611 98.9424 0.930176 101.473 0.930176 104.595C0.930176 107.716 6.37611 110.247 13.0939 110.247C19.8117 110.247 25.2577 107.716 25.2577 104.595C25.2577 103.579 24.678 102.626 23.6686 101.803L73.1308 80.8036L66.5149 93.2924C66.4517 93.2921 66.3892 93.2902 66.3258 93.2902C59.608 93.2902 54.1621 95.8208 54.1621 98.9424C54.1621 102.064 59.608 104.595 66.3258 104.595C73.0436 104.595 78.4895 102.064 78.4895 98.9424C78.4895 96.4021 74.8827 94.2533 69.9192 93.5411L77.1145 79.9586L122.665 112.681C119.279 114.048 117.135 116.062 117.135 118.31C117.135 122.428 124.318 125.766 133.179 125.766C142.04 125.766 149.224 122.428 149.224 118.31C149.224 114.193 142.04 110.855 133.179 110.855C130.771 110.855 128.489 111.103 126.439 111.545L82.2274 79.7839L129.314 84.5174Z",
    fill: "url(#paint0_linear_3065_8877)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.535 38.2024H101.532C102.966 34.8921 103.765 31.2428 103.765 27.4056C103.765 12.3878 91.5904 0.213379 76.5726 0.213379C61.5547 0.213379 49.3804 12.3878 49.3804 27.4056C49.3804 31.2428 50.1794 34.8921 51.6132 38.2024H51.6097L51.6332 38.2462C52.2044 39.5584 52.8776 40.8149 53.6401 42.0096L74.1507 76.1918C74.6279 77.0862 75.5591 77.6452 76.5729 77.6452C77.5866 77.6452 78.5179 77.0865 78.9951 76.1918L99.5035 42.0131C100.268 40.8156 100.943 39.5565 101.515 38.2409L101.535 38.2024Z",
    fill: "url(#paint1_linear_3065_8877)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5727 35.7702C82.2318 35.7702 86.8193 31.1827 86.8193 25.5237C86.8193 19.8646 82.2318 15.2771 76.5727 15.2771C70.9137 15.2771 66.3262 19.8646 66.3262 25.5237C66.3262 31.1827 70.9137 35.7702 76.5727 35.7702Z",
    fill: "url(#paint2_linear_3065_8877)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6047 32.1303C79.7206 36.0143 73.4237 36.0143 69.5397 32.1303C65.6915 28.2821 65.6584 22.0662 69.4359 18.1746C69.4 18.2096 69.3625 18.2428 69.3269 18.2784C65.3253 22.2799 65.3253 28.7678 69.3269 32.769C73.3284 36.7706 79.8162 36.7706 83.8178 32.769C87.8194 28.7674 87.8194 22.2796 83.8178 18.2781C83.7822 18.2424 83.7447 18.2093 83.7087 18.1743C87.4859 22.0662 87.4531 28.2818 83.6047 32.1303Z",
    fill: "#FF5959"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M76.4743 88.9195C97.7419 88.9195 114.983 83.5484 114.983 76.9227C114.983 70.297 97.7419 64.9258 76.4743 64.9258C55.2066 64.9258 37.9658 70.297 37.9658 76.9227C37.9658 83.5484 55.2066 88.9195 76.4743 88.9195Z",
    fill: "url(#paint3_radial_3065_8877)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3065_8877",
    x1: 75.8745,
    y1: 30.1961,
    x2: 75.8745,
    y2: 115.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3065_8877",
    x1: 90.8484,
    y1: 66.846,
    x2: 65.1607,
    y2: -4.1334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF3D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#D84447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5377,
    stopColor: "#E44746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#E84A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9029,
    stopColor: "#F55352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3065_8877",
    x1: 91.9722,
    y1: 40.9231,
    x2: 65.503,
    y2: 14.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3065_8877",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.473 76.9188) scale(37.1462 9.75848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1503,
    stopColor: "#1C1819",
    stopOpacity: 0.8497
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6588,
    stopColor: "#070707",
    stopOpacity: 0.3412
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressMapIcon);
export default __webpack_public_path__ + "static/media/addressMapIcon.610f8fa4b0e5c69ed36b67e742c0033f.svg";
export { ForwardRef as ReactComponent };